module.exports = __webpack_public_path__ + "img/work.cf994354.svg";